export interface KeyValue {
  [key: string]: any;
}

export default function safeObj<TData extends KeyValue>(
  obj: TData,
  isEmptyStringFalsy = true,
  isZeroFalsy = true
) {
  Object.keys(obj).forEach((key) => {
    const typeOfValue = typeof obj[key];
    let hasValue =
      typeOfValue === "string"
        ? isEmptyStringFalsy
          ? !!obj[key]
          : true
        : !!obj[key];

    if (!isZeroFalsy && typeOfValue === "number") {
      hasValue = true;
    }

    if (!hasValue) {
      delete obj[key];
    }
  });

  return obj;
}
